import * as time from '@/utils/time.ts';

export const PARSER_NAME_SUFFIX = '__REQUEST';
export const DEFAULT_REQUEST_TIMEOUT = time.second * 30;
